export class Claim {
  id?: string;
  registerDate?: Date;
  clientId: string;
  projectId?: string;
  boUserId?: string;
  closeDate? : Date;
  data: ClaimDetailData;
}
export class ClaimDetailData {
  paymentOrders: string[];
  description: string;
  categoryCode: string;
  statusCode: string;
}

export interface ClaimDTO {
  clientId: string;
  data: ClaimDetailData;
}

export enum ClaimStatus {
  OPEN = 'O',
  CLOSED = 'C',
}

export enum StatusClaim{
  UNDER_ANALYSIS = "UNDER_ANALYSIS",
  UNDER_NEGOTIATION = "UNDER_NEGOTIATION",
  CLOSED = "CLOSE",
}

export enum DontClaim{
  NO_CLAIM = "NO_CLAIM",
}
